<template>
    <div>
        <el-header class="sup-steps-wrap">
            <el-steps :space="600" :active="$root.auditStep" finish-status="success" simple class="sup-steps">
                <el-step title="资料待审核"></el-step>
                <el-step title="资料审核中"></el-step>
                <el-step title="审核通过"></el-step>
            </el-steps>
        </el-header>
        <el-container class="main-container">
            <el-aside width="220px" class="sup-menu-wrap">
                <h5 style="margin-top:5px;">供应商基本信息</h5>
                <a @click.prevent="hint('/supplier')" :class="$route.name=='Supplier'&&'router-link-exact-active router-link-active active'" class="menu-item">基本信息</a>
                <a @click.prevent="hint('/supplier/gysfj')" :class="$route.name=='Gysfj'&&'router-link-exact-active router-link-active active'" class="menu-item">上传承诺函</a>
                <a @click.prevent="hint('/supplier/other')" :class="$route.name=='Other'&&'router-link-exact-active router-link-active active'" class="menu-item">其他信息</a>
                <a @click.prevent="hint('/supplier/contact')" :class="$route.name=='Contact'&&'router-link-exact-active router-link-active active'" class="menu-item">联系人信息</a>
                <a @click.prevent="hint('/supplier/bankinfo')" :class="$route.name=='BankInfo'&&'router-link-exact-active router-link-active active'" class="menu-item">银行信息</a>
                <a @click.prevent="hint('/supplier/spss')" :class="$route.name=='Spss'&&'router-link-exact-active router-link-active active'" class="menu-item">专业类别</a>
                <a @click.prevent="hint('/supplier/agreement')" :class="$route.name=='Agreement'&&'router-link-exact-active router-link-active active'" class="menu-item">战略信息</a>
                <a @click.prevent="hint('/supplier/manager')" :class="$route.name=='Manager'&&'router-link-exact-active router-link-active active'" class="menu-item">项目经理</a>
                <router-link class="menu-item" to="/supplier/audit" :class="{active: $route.path=='/supplier/audit'}">审核记录</router-link>
                <router-link class="menu-item" to="/supplier/changeHistory" :class="{active: $route.path=='/supplier/changeHistory'}">变更历史</router-link>
                <router-link v-if="xgxxIsShow" class="menu-item" to="/supplier/changename" :class="{active: $route.path=='/supplier/changename'}">修改信息</router-link>
                <router-link class="menu-item" to="/supplier/pass" :class="{active: $route.path=='/supplier/pass'}">修改密码</router-link>
                <router-link v-if="!isPreAudit" class="menu-item" to="/supplier/bind" :class="{active: $route.path=='/supplier/bind'}">手机绑定</router-link>
            </el-aside>
            <el-main class="sup-wrap">
                <router-view v-loading="$root.loading"></router-view>
            </el-main>
        </el-container>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { SUPPLIER_BASIC_FORM, SUPPLIER_USER_INFO } from '@/store/mutation-types'
    import banner from '@/assets/imgs/banner.png'
    import util from '@/util'
    import apis from '@/store/apis'


    export default {
        name: 'Supplier',
        data () {
            return {
                activeIndex: 1,
                isPreAudit: false,  // 是否为预审核 flag
                xgxxIsShow: false,  // 修改信息菜单是否展示
                basicIsShow: true,  // 判断信息是否修改
                hasYRZ: {flag:false},//是否含有已认证的专业类别
                hasRKSPZ: {flag:false}//是否含有入库审批中的专业类别
            }
        },
        computed: mapGetters(['regStep']),
        methods: {
            ...mapActions(['getStockStep','setIsShowBasic','setHasYrz']),
            ...mapMutations({setBasicInfo: SUPPLIER_BASIC_FORM, setUserInfo: SUPPLIER_USER_INFO}),
            hint(path){
                if(~['Supplier', 'Other', 'Contact','Service','Spss','Manager','Gysfj', 'BankInfo'].indexOf(this.$route.name)){
                    if(window.sessionStorage.getItem(this.$route.name)!=='saved'){
                        this.$confirm('如有信息调整，请点击提交按钮进行提交，否则数据将不被保存', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push(path)
                        }).catch(() => {
                            return
                        })
                    }else{
                        this.$router.push(path)
                    }
                }else{
                    this.$router.push(path)
                }
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasYRZ,this.hasRKSPZ)
            }
        },
        created(){
            this.$root.loading = true;
            window.ji = this
            this.$root.isPublic = false
            this.$root.navs = [{name:'基本信息',path:'/supplier'}]
            this.$root.headImage.src = banner
            let stockId = window.sessionStorage.getItem('stockId')
            if(stockId){
                console.log(stockId)
                let supplierUserInfo = window.sessionStorage.getItem('supplierUserInfo'), supplierStockInfo=window.sessionStorage.getItem('supplierStockInfo')
                if(supplierUserInfo){
                    this.setUserInfo(JSON.parse(supplierUserInfo))
                    this.setBasicInfo(JSON.parse(supplierStockInfo))
                }
                Promise.all([
                    this.getStockStep(),
                    this.checkStatus()
                ]).then(r => (
                        this.$root.auditStep = parseInt(r[0].data.value) || 1,
                        // 判断是否为预审核
                        window.sessionStorage.setItem('isPreAudit', (r[0].data.value != '3' ?  0 : 1)),
                        this.isPreAudit = window.sessionStorage.getItem('isPreAudit')==1,
                        this.$nextTick(function(){
                            if(this.hasYRZ.flag){
                                this.xgxxIsShow = true
                            }
                            if(this.hasRKSPZ.flag){//含有审批中的专业类别不让修改
                                this.basicIsShow = false;
                            }
                            this.setIsShowBasic(this.basicIsShow)
                            this.setHasYrz(this.hasYRZ.flag);
                            window.sessionStorage.setItem('basicIsShow', this.basicIsShow),
                            window.sessionStorage.setItem('hasYRZ', this.hasYRZ.flag),
                            this.$root.loading = false
                        })
                )).catch(err => (this.$root.loading = false,console.log(err)))
            }
        },
        mounted(){
            this.$nextTick(function(){this.$root.activeIndex = 'setting'})
        }
    }
</script>

<style>
    .info-head{
        background: url(../../../assets/imgs/icon-info.png) 0 center no-repeat;
        padding: 20px 30px;
        font-size: 14px;
        margin-top: -20px;
        border-bottom: 1px solid #e6e6e6;
    }
    .info-head .el-button{
        float: right;
        margin: -15px -28px;
    }
    .item-ul .el-button{
        float: right;
        margin: -15px 0;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
    @import '../../../assets/common.css';

    .sup-wrap{
        margin: 0 auto 20px;
    }
    .sup-steps{
        margin-bottom: 20px;
    }
    .sup-steps-wrap{
        width: 1200px;
        margin: 20px auto;
    }
    .sup-menu-wrap{
        background: #f5f5f5;
        padding: 16px;
        margin-bottom: 20px;
        @apply --inputBorder;
    & .menu-item{
          display: block;
          margin: 16px auto;
          font-size: 13px;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
          background-color: #fff;
          color: #666;
          cursor: pointer;
          @apply --inputBorder;
    &:hover,
    &.active {
         color: var(--mainColor);
         border-color: var(--mainColor);
     }
    }
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Supplier.vue